import { createContext } from "react";

/**
 * Where a phone list puts its "Select" button (#647): the end of the view
 * tabs row, so it no longer takes a row of its own above the cards.
 * `SectionPage` provides the element and `FilterBar` draws it; a list outside
 * a section has none and keeps its own row.
 */
export const ListToolsSlotContext = createContext<HTMLElement | null>(null);
